export default __webpack_public_path__ + "static/media/logoControlB.409786ea.png";